'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

require('./ValidationInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = require('lodash/lang/isEmpty');

var FormItem = _antd.Form.Item;

var ValidationInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ValidationInput, _Component);

  function ValidationInput() {
    (0, _classCallCheck3.default)(this, ValidationInput);
    return (0, _possibleConstructorReturn3.default)(this, (ValidationInput.__proto__ || (0, _getPrototypeOf2.default)(ValidationInput)).apply(this, arguments));
  }

  (0, _createClass3.default)(ValidationInput, [{
    key: 'render',
    value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;

      return _react2.default.createElement(
        'div',
        { className: 'validationInputForm__component' },
        _react2.default.createElement(
          _antd.Form,
          null,
          _react2.default.createElement(
            FormItem,
            null,
            getFieldDecorator('Name', {
              rules: [{ required: true, message: 'Use 255 characters or less', max: 255 }],
              initialValue: this.props.name,
              validateTrigger: 'onKeyUp'
            })(_react2.default.createElement(_antd.Input, null))
          )
        )
      );
    }
  }]);
  return ValidationInput;
}(_react.Component), _class.propTypes = {
  form: _propTypes2.default.shape({
    validateFields: _propTypes2.default.func.isRequired,
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldError: _propTypes2.default.func.isRequired
  }).isRequired,
  name: _propTypes2.default.string.isRequired
}, _temp);


var ValidationInputForm = _antd.Form.create({
  onFieldsChange: function onFieldsChange(props, fields) {
    var Name = fields.Name;

    if (!Name.dirty) {
      if (isEmpty(Name.errors)) {
        props.onChange(props.recordId, 'name', Name.value);
      } else {
        props.hasValidationErrors(true);
      }
    }
  }
})(ValidationInput);

exports.default = ValidationInputForm;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Ruleset/components/ValidationInput.js
// module id = 3688
// module chunks = 3